module.exports = __webpack_public_path__ + "static/img/1-13.18bfcb0.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/1-13.png
// module id = 214
// module chunks = 0